<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { SCHEDULED_VISITS_TEXT } from '../utils/visitScheduledPresenter';

const props = defineProps({
  client: { type: Object, default: () => ({}) },
  startExpanded: { type: Boolean, default: false },
});

const emit = defineEmits(['profile', 'message', 'expand']);

const clientName = computed(() => props.client.name || 'Cliente');
const clientPhone = computed(
  () => props.client.phone || props.client.clientPhone || ''
);
const clientSince = computed(() => props.client.clientSince || '');
const nextVisitDescription = computed(
  () => props.client.nextVisitLabel || 'Próxima visita: —'
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard
    density="tight"
    expandable
    :start-expanded="startExpanded"
    :expand-label="SCHEDULED_VISITS_TEXT.EXPAND_LABEL"
    :collapse-label="SCHEDULED_VISITS_TEXT.COLLAPSE_LABEL"
    @toggle="emit('expand', $event)"
  >
    <template #header>
      <div class="min-w-0">
        <h3 class="truncate text-[15px] font-semibold text-lais-text">
          {{ clientName }}
        </h3>
        <p class="mt-1 text-[12px] text-lais-text-muted">
          {{ nextVisitDescription }}
        </p>
      </div>
    </template>
    <div class="-mx-5 -my-4 divide-y divide-lais-border-soft">
      <dl
        v-if="clientPhone || clientSince"
        class="grid gap-2 px-5 py-3 text-[12px] text-lais-text-body"
      >
        <div v-if="clientPhone" class="flex items-center justify-between gap-3">
          <dt class="font-semibold text-lais-text-muted">Telefone</dt>
          <dd class="font-semibold text-lais-text">{{ clientPhone }}</dd>
        </div>
        <div v-if="clientSince" class="flex items-center justify-between gap-3">
          <dt class="font-semibold text-lais-text-muted">Cliente desde</dt>
          <dd class="font-semibold text-lais-text">{{ clientSince }}</dd>
        </div>
      </dl>
      <button
        type="button"
        class="flex w-full items-center gap-2 px-5 py-3 text-left text-[13px] font-semibold text-lais-primary transition-colors hover:bg-lais-primary-50"
        @click="emit('message')"
      >
        <span class="i-lucide-message-circle size-4" aria-hidden="true" />
        {{ SCHEDULED_VISITS_TEXT.SEND_MESSAGE }}
      </button>
      <button
        type="button"
        class="flex w-full items-center gap-2 px-5 py-3 text-left text-[13px] font-semibold text-lais-text transition-colors hover:bg-lais-bg-soft"
        @click="emit('profile')"
      >
        <span class="i-lucide-user-round size-4" aria-hidden="true" />
        {{ SCHEDULED_VISITS_TEXT.VIEW_PROFILE }}
      </button>
    </div>
  </LaisCard>
</template>
